import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';
import { ButtonBase } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

const CatalogScrollButton = React.forwardRef(
  ({ onClick, direction, className, disabled }, ref) => {
    const { t } = useTranslation();

    return (
      <ButtonBase
        ref={ref}
        onClick={onClick}
        data-testid={`Menu.TabScrollButton.${direction}`}
        sx={{
          opacity: disabled ? 0 : 0.8,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 40,
          my: '3px',
          mr: direction === 'right' ? '3px' : 0,
          ml: direction === 'left' ? '3px' : 0,
          flexShrink: 0,
        }}
        className={`${className} MuiTabScrollButton-root MuiTabScrollButton-horizontal`}
        disabled={disabled}
        focusRipple
        aria-label={
          direction === 'left'
            ? t('catalog.tabs.scrollLeft')
            : t('catalog.tabs.scrollRight')
        }
      >
        {direction === 'left' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </ButtonBase>
    );
  },
);
export default CatalogScrollButton;
